import { motion } from 'framer-motion';
import { Hash } from 'lucide-react';

const naicsCodes = [
  { code: '541611', description: 'Administrative Management & General Management Consulting', primary: true },
  { code: '541618', description: 'Other Management Consulting Services', primary: false },
  { code: '541512', description: 'Computer Systems Design Services', primary: false },
  { code: '541519', description: 'Other Computer Related Services', primary: false },
  { code: '518210', description: 'Data Processing, Hosting, and Related Services', primary: false },
  { code: '221310', description: 'Water Supply and Irrigation Systems', primary: false },
];

const companyInfo = [
  { label: 'Legal Name', value: 'Cole Utilities, LLC' },
  { label: 'Location', value: 'Atlanta, GA' },
  { label: 'Structure', value: 'Small Business' },
  { label: 'CAGE Code', value: '9Y0X3' },
  { label: 'SAM Registered', value: 'Yes' },
];

export default function NaicsCodes() {
  return (
    <section
      id="naics"
      data-testid="naics-section"
      className="py-20 lg:py-24 bg-[#141414] border-t border-[#2A2A2A]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* NAICS Codes */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-body text-[#B8102E] text-xs tracking-[0.3em] uppercase mb-4">
              Contract Codes
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight mb-8">
              NAICS Codes
            </h2>
            <div className="space-y-3">
              {naicsCodes.map((item, i) => (
                <motion.div
                  key={item.code}
                  initial={{ opacity: 0, x: -15 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.06 }}
                  data-testid={`naics-code-${i}`}
                  className="flex items-start gap-3 p-3 rounded-lg hover:bg-[#0A0A0A]/60 transition-colors group"
                >
                  <Hash className="h-4 w-4 text-[#B8102E] mt-0.5 flex-shrink-0" />
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="font-body text-sm font-semibold text-[#B8102E]">
                        {item.code}
                      </span>
                      {item.primary && (
                        <span className="text-[9px] font-body uppercase tracking-wider bg-[#B8102E]/15 text-[#B8102E] px-2 py-0.5 rounded">
                          Primary
                        </span>
                      )}
                    </div>
                    <p className="font-body text-sm text-[#A3A3A3] mt-0.5">
                      {item.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Company Snapshot */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <p className="font-body text-[#B8102E] text-xs tracking-[0.3em] uppercase mb-4">
              At a Glance
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight mb-8">
              Company Snapshot
            </h2>
            <div className="p-6 bg-[#0A0A0A] border border-[#2A2A2A] rounded-lg">
              <div className="space-y-4">
                {companyInfo.map((item, i) => (
                  <div
                    key={item.label}
                    data-testid={`company-info-${i}`}
                    className="flex justify-between items-center py-2 border-b border-[#2A2A2A] last:border-0"
                  >
                    <span className="font-body text-sm text-[#737373]">{item.label}</span>
                    <span className="font-body text-sm text-white font-medium">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-6 p-5 border border-[#B8102E]/20 rounded-lg bg-[#B8102E]/5">
              <p className="font-body text-xs text-[#B8102E] uppercase tracking-wider mb-2">
                Founder & Principal
              </p>
              <p className="font-heading text-lg text-white font-semibold">Justin C. McCain</p>
              <p className="font-body text-sm text-[#A3A3A3] mt-1">470-342-2327</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
